<!-- Modal obligatorio: no se puede cerrar mientras el chat esté bloqueado -->
<ion-modal [isOpen]="show" cssClass="contact-finder-modal" [backdropDismiss]="true" [canDismiss]="canDismissHandler"
  (ionModalDidDismiss)="onDidDismiss()">
  <ng-template>
    <div class="dialog-scroll-container">
      <div class="dialog-wrapper relative">
        <!-- Botón cerrar -->
        <ion-button mode="ios" fill="clear" (click)="dialogDismissed.emit()" class="absolute top-0 right-0 z-10">
          <ion-icon color="secondary" src="../../../assets/svg/close.svg" class="text-[20px]" />
        </ion-button>

        <!-- Título -->
        <h2 class="dialog-title">
          {{ t.getItemTranslated('CONTACT_FINDER_DIALOG.TITLE') || 'Contacta con el Finder' }}
        </h2>

        <!-- Descripción -->
        <p class="dialog-description" [innerHTML]="t.getItemTranslated('CONTACT_FINDER_DIALOG.DESCRIPTION')"></p>

        <p class="dialog-subtitle">
          {{ t.getItemTranslated('CONTACT_FINDER_DIALOG.SUBTITLE') || 'Para poder contactar con el Finder de este objeto, tienes dos opciones:' }}
        </p>

        <!-- ═══ Opción 1: Coordinar por chat ═══ -->
        <div class="collapsible-section">
          <button class="collapsible-header" (click)="toggleChatSection()" type="button">
            <span class="collapsible-label">
              {{ t.getItemTranslated('CONTACT_FINDER_DIALOG.OPTION_CHAT') || 'Coordinar por chat la entrega' }}
            </span>
            <ion-icon [name]="chatSectionOpen ? 'chevron-up' : 'chevron-down'" class="collapsible-icon"></ion-icon>
          </button>

          <div class="collapsible-body collapsible-body-animated" [class.open]="chatSectionOpen">
            <div class="collapsible-body-inner">
              <p class="chat-description-text">
                {{ t.getItemTranslated('CONTACT_FINDER_DIALOG.CHAT_DESCRIPTION') || 'Envía mensajes y fotos en tiempo real para coordinar la entrega fácilmente.' }}
                <strong>{{ t.getItemTranslated('CONTACT_FINDER_DIALOG.CHAT_ACTIVATION') || 'Activación inmediata.'
                  }}</strong>
              </p>

              <ion-button expand="block" color="secondary" class="chat-pay-button"
                [disabled]="paymentLoading" (click)="requestPay()">
                <ion-spinner *ngIf="paymentLoading" name="crescent" slot="start"></ion-spinner>
                {{ t.getItemTranslated('CONTACT_FINDER_DIALOG.CHAT_BUTTON') || 'Usar chat ahora' }}
                ({{ premiumChatAmount | number:'1.2-2' }}€)
                <ion-icon name="chevron-forward" slot="end"></ion-icon>
              </ion-button>

              <p class="chat-also-text">
                {{ t.getItemTranslated('CONTACT_FINDER_DIALOG.ALSO_RECOVER') || 'También puedes recuperar tu objeto sin usar el chat.' }}
              </p>
            </div>
          </div>
        </div>

        <!-- ═══ Opción 2: Continuar sin chat ═══ -->
        <div class="collapsible-section">
          <button class="collapsible-header" (click)="toggleNoChatSection()" type="button">
            <span class="collapsible-label">
              {{ t.getItemTranslated('CONTACT_FINDER_DIALOG.OPTION_NO_CHAT') || 'Continuar sin usar el chat' }}
            </span>
            <ion-icon [name]="noChaSectionOpen ? 'chevron-up' : 'chevron-down'" class="collapsible-icon"></ion-icon>
          </button>

          <div class="collapsible-body collapsible-body-animated" [class.open]="noChaSectionOpen">
            <div class="collapsible-body-inner">
              <!-- Mensaje aún no enviado: textarea editable -->
              <ng-container *ngIf="!isMessageReadOnly">
                <div class="no-chat-intro">
                  <p *ngFor="let introLine of noChatIntroLines" class="no-chat-intro-line" [innerHTML]="t.getItemTranslated(introLine.key) || introLine.fallback"></p>
                </div>

                <div class="textarea-wrapper">
                  <textarea class="free-message-textarea" [(ngModel)]="freeMessage" [maxlength]="MAX_MESSAGE_LENGTH"
                    [placeholder]="t.getItemTranslated('CONTACT_FINDER_DIALOG.NO_CHAT_PLACEHOLDER') || 'Añadir respuesta (opcional)...'"
                    rows="3"></textarea>
                  <span class="char-counter">{{ freeMessage.length }}/{{ MAX_MESSAGE_LENGTH }}</span>
                </div>

                <div class="no-chat-highlights">
                  <div class="no-chat-highlight" *ngFor="let highlight of noChatHighlights">
                    <ion-icon [name]="highlight.icon" class="no-chat-highlight-icon"></ion-icon>
                    <p class="no-chat-highlight-text" [innerHTML]="t.getItemTranslated(highlight.key) || highlight.fallback"></p>
                  </div>
                </div>

                <div class="flex justify-end w-full">
                    <ion-button color="secondary" class="send-message-button"
                    [disabled]="sendingMessage || !freeMessage.trim()" (click)="sendFreeMessage()">
                    <ion-spinner *ngIf="sendingMessage" name="crescent" slot="start"></ion-spinner>
                    {{ t.getItemTranslated('CONTACT_FINDER_DIALOG.SEND_MESSAGE') || 'Enviar' }}
                    <ion-icon name="chevron-forward" slot="end"></ion-icon>
                  </ion-button>
                </div>
              </ng-container>

              <!-- Mensaje ya enviado: solo lectura -->
              <ng-container *ngIf="isMessageReadOnly">
                <p class="no-chat-instruction">
                  {{ t.getItemTranslated('CONTACT_FINDER_DIALOG.MESSAGE_SENT_LABEL') || 'Tu mensaje enviado:' }}
                </p>

                <div class="sent-message-card">
                  <p class="sent-message-text">{{ ownerFreeMessage }}</p>
                </div>

                <!-- Respuesta del finder (si ya respondió) -->
                <ng-container *ngIf="hasFinderResponse">
                  <p class="no-chat-instruction finder-response-label">
                    {{ t.getItemTranslated('CONTACT_FINDER_DIALOG.FINDER_RESPONSE_LABEL') || 'Respuesta del Finder:' }}
                  </p>
                  <div class="sent-message-card">
                    <p class="sent-message-text">{{ finderFreeMessage }}</p>
                  </div>
                </ng-container>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</ion-modal>

<!-- Premium chat payment confirmation modal -->
<app-dialog [show]="showPaymentConfirm" [close]="true" (toggle)="cancelPaymentConfirm()">
  <div class="flex flex-col gap-3 p-2 text-left">
    <h3 class="text-lg font-semibold text-center">{{ 'PREMIUM_CHAT_CONFIRM.TITLE' | translate }}</h3>
    <p class="text-[13px] leading-snug" [innerHTML]="'PREMIUM_CHAT_CONFIRM.BODY_1' | translate"></p>
    <p class="text-[13px] leading-snug">{{ 'PREMIUM_CHAT_CONFIRM.BODY_2' | translate }}</p>
    <p class="text-[13px] leading-snug" [innerHTML]="('PREMIUM_CHAT_CONFIRM.BODY_3' | translate:{ amount: premiumChatAmount })"></p>
    <p class="text-[13px] leading-snug" [innerHTML]="'PREMIUM_CHAT_CONFIRM.BODY_4' | translate"></p>
    <div class="public-profile-share-callout">
      <img
        src="../../../assets/svg/public-profile-share.svg"
        alt=""
        aria-hidden="true"
        class="public-profile-share-callout__icon"
      />
      <p class="public-profile-share-callout__text">
        {{ 'PUBLIC_PROFILE_SHARE_DIALOG.PREMIUM_CHAT_OWNER_NOTICE' | translate }}
        {{ 'PUBLIC_PROFILE_SHARE_DIALOG.REVIEW_SETTINGS_PREFIX' | translate }}
        <a href="#" class="font-semibold underline" (click)="openPublicProfileSettings($event)">
          {{ 'PUBLIC_PROFILE_SHARE_DIALOG.SETTINGS_LINK' | translate }}
        </a>.
      </p>
    </div>
    <label class="flex items-start gap-2 mt-2 cursor-pointer">
      <input type="checkbox" [(ngModel)]="termsAccepted" class="mt-1" />
      <span class="text-[12px] leading-snug terms-label" (click)="openTerms($event)" [innerHTML]="'PREMIUM_CHAT_CONFIRM.CHECKBOX_LABEL' | translate"></span>
    </label>
    <ion-button expand="block" color="primary" [disabled]="!termsAccepted || paymentLoading" (click)="confirmPay()" class="mt-2">
      {{ 'PREMIUM_CHAT_CONFIRM.PAY_BUTTON' | translate }}
    </ion-button>
    <p class="text-[11px] text-center text-gray-400">{{ 'PREMIUM_CHAT_CONFIRM.FOOTER' | translate }}</p>
  </div>
</app-dialog>